module.exports = __webpack_public_path__ + "img/img_futa_wavestitch.1c1a977c.png";